import Config from '@config';
import { initializeMeteringPointApi } from '@gasbi/shared/common/features/meteringPoint';
import { useSelector } from 'react-redux';

import { cachedItemByIdSelector } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

const meteringPoint = initializeMeteringPointApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  meteringPointApi,
  useGetMeteringPointsQuery,
  useLazyGetMeteringPointsQuery,
  useLazyGetMeteringPointByIdQuery,
  useGetMeteringPointByIdQuery,
  useCreateMeteringPointMutation,
  useUpdateMeteringPointMutation,
  useGetMeteringPointsInfiniteQuery,
  useGetMeteringPointByIdStatusHistoryInfiniteQuery,
  useGetMeteringPointDeviceGridifyInfiniteQuery,
} = meteringPoint;

const getCachedMeteringPointByIdSelector = cachedItemByIdSelector(
  'meteringPointApi',
  'getMeteringPointsI',
);

export const useGetCachedMeteringPointByIdSelector = id =>
  useSelector(getCachedMeteringPointByIdSelector(id));
